import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessToken: undefined,
  userId: undefined,
  photo: undefined,
  accountType: undefined,
  firstName: undefined,
  lastName: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
});

export default authSlice.reducer;
